module.exports = __webpack_public_path__ + "static/img/bg_1.b438f56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/bg_1.jpg
// module id = x0iG
// module chunks = 0